<article class="lk-intro">
  <h3 class="lk-intro__title">
    <i eIcon icon="lock-keyhole" family="solid"></i>
    {{ title() }}
  </h3>
  @for (section of sections; track section.key) {
    @if (section.key === 'tableOrder') {
      <!-- Verkleinde, klikbare Global Cycles-tabel vóór de tabel-uitleg;
           klik opent de volledige tabel in een versleepbaar zwevend paneel. -->
      <button
        #gcPreviewHost
        type="button"
        class="lk-intro__table-preview"
        [style.height.px]="previewHeight()"
        [attr.title]="previewLabel()"
        [attr.aria-label]="previewLabel()"
        data-test-id="locks-keys-global-cycles-preview"
        (click)="openGlobalCyclesTable()"
      >
        <div
          #gcPreviewInner
          class="lk-intro__table-preview-inner"
          [style.transform]="'scale(' + previewScale() + ')'"
        >
          <hd-global-cycles-table [highlightPeriodId]="null"></hd-global-cycles-table>
        </div>
      </button>
    }
    <hd-locks-keys-section
      [prefix]="'intro.' + section.key"
      [sectionKey]="section.key"
      testIdPrefix="locks-keys-intro"
      [linkPanel]="section.linkPanel"
    ></hd-locks-keys-section>
  }

  <!-- Doorklikkaarten naar de vervolgpanelen (Mens na 2027, biologie, Rave en
       Penta, nodale omgeving): bewust onderaan, de leesflow eindigt precies
       waar die verhalen beginnen. -->
  <nav class="lk-intro__read-on" data-test-id="locks-keys-read-on">
    <h4>{{ readOnTitle() }}</h4>
    @for (panelId of readingPanelIds; track panelId) {
      <hd-locks-keys-panel-link [panel]="panelId"></hd-locks-keys-panel-link>
    }
  </nav>
</article>
